import { Link } from "react-router-dom";

const LOGO_SRC =
  "https://customer-assets-jai6qajn.emergentagent.net/job_mauresk-offshore/artifacts/ln24fejl_MAURESK%20LOGO%20%281%29.png";

// Official MAURESK wordmark logo
export default function Logo({ className = "" }) {
  return (
    <Link
      to="/"
      data-testid="logo-link"
      className={`inline-flex items-center ${className}`}
      aria-label="Mauresk Services home"
    >
      <img
        src={LOGO_SRC}
        alt="Mauresk Services"
        loading="eager"
        decoding="async"
        className="h-7 w-auto sm:h-8"
      />
    </Link>
  );
}
